(() => {
  const STORAGE_KEY = 'mattr-wishlist';
  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  const SEP = '::';

  function makeKey(handle, variantId){
    const h = String(handle || '').trim();
    const v = String(variantId || '').trim();
    if(!h) return '';
    return v ? `${h}${SEP}${v}` : h;
  }

  function parseKey(key){
    const raw = String(key || '');
    const i = raw.lastIndexOf(SEP);
    if(i === -1) return {handle: raw, variantId: ''};
    return {handle: raw.slice(0, i), variantId: raw.slice(i + SEP.length)};
  }

  function readWishlist(){
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? [...new Set(value.filter(Boolean).map(String))] : [];
    } catch(e){ return []; }
  }

  function writeWishlist(items){
    const clean = [...new Set(items.filter(Boolean).map(String))];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(clean));
    document.dispatchEvent(new CustomEvent('nakr:wishlist-changed', {detail:{items:clean}}));
    syncHearts();
    renderCartFavorites();
  }

  function heartIcon(){
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z"></path></svg>';
  }

  function buttonKey(btn){
    return makeKey(btn.dataset.productHandle, btn.dataset.variantId);
  }

  function syncHearts(){
    const saved = new Set(readWishlist());
    document.querySelectorAll('[data-nakr-wishlist-heart]').forEach(btn => {
      const key = buttonKey(btn);
      const active = key ? saved.has(key) : false;
      btn.classList.toggle('is-saved', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Retirer des favoris' : 'Ajouter aux favoris');
    });
  }

  function detailsFromHref(href){
    try {
      const u = new URL(href, window.location.origin);
      const match = u.pathname.match(/\/products\/([^/?#]+)/);
      if(!match) return null;
      return {handle: decodeURIComponent(match[1]), variantId: u.searchParams.get('variant') || ''};
    } catch(e){
      const match = String(href || '').match(/\/products\/([^?#/]+)/);
      return match ? {handle: match[1], variantId: ''} : null;
    }
  }

  function createHeart(host, details){
    if(!host || !details || !details.handle) return;
    if(host.querySelector('[data-nakr-wishlist-heart]')) return;
    const btn = document.createElement('button');
    btn.type='button';
    btn.className='nakr-wishlist-heart';
    btn.dataset.nakrWishlistHeart='';
    btn.dataset.productHandle=details.handle;
    if(details.variantId) btn.dataset.variantId=details.variantId;
    btn.setAttribute('aria-label','Ajouter aux favoris');
    btn.setAttribute('aria-pressed','false');
    btn.innerHTML=heartIcon();
    try {
      if(window.getComputedStyle(host).position === 'static') host.style.position = 'relative';
    } catch(e){}
    host.appendChild(btn);
  }

  function injectHearts(){
    const configs = [
      ['.card-wrapper.product-card-wrapper', '.card__inner', 'a[href*="/products/"]'],
      ['.nlp-card', '.nlp-photo-wrap', 'a.nlp-photo[href*="/products/"]'],
      ['.nakr-new-rail__card', '.nakr-new-rail__media', null],
      ['.nhc-world-editorial__item', '.nhc-world-editorial__media', null],
      ['.sekany-shop-card', '.sekany-shop-card__media', 'a.sekany-shop-card__media[href*="/products/"]'],
      ['.sekany-variant-card', '.sekany-variant-card__media', null]
    ];

    configs.forEach(([cardSelector, hostSelector, linkSelector]) => {
      document.querySelectorAll(cardSelector).forEach(card => {
        if(card.querySelector('[data-nakr-wishlist-heart]')) return;
        const host = card.matches(hostSelector) ? card : card.querySelector(hostSelector);
        let link = null;
        if(linkSelector) link = card.querySelector(linkSelector);
        if(!link && card.matches('a[href*="/products/"]')) link = card;
        if(!link) link = card.querySelector('a[href*="/products/"]');
        if(!host || !link) return;
        const details = detailsFromHref(link.getAttribute('href'));
        createHeart(host, details);
      });
    });
    syncHearts();
  }

  function toggle(handle, variantId){
    const key = makeKey(handle, variantId);
    if(!key) return;
    const items = readWishlist();
    const i = items.indexOf(key);
    if(i >= 0) items.splice(i,1); else items.push(key);
    writeWishlist(items);
  }

  function money(cents){
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style:'currency',currency}).format((Number(cents)||0)/100);
    } catch(e){ return ((Number(cents)||0)/100).toFixed(2) + ' ' + currency; }
  }

  async function loadProduct(handle){
    const url = rootUrl.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js';
    const response = await fetch(url, {credentials:'same-origin'});
    if(!response.ok) throw new Error('product');
    return response.json();
  }

  function variantFor(product, variantId){
    if(!product || !variantId || !Array.isArray(product.variants)) return null;
    return product.variants.find(v => String(v.id) === String(variantId)) || null;
  }

  async function renderOneContainer(container, keys){
    const list = container.querySelector('[data-nakr-favorites-list]');
    const count = container.querySelector('[data-nakr-favorites-count]');
    if(count) count.textContent = String(keys.length);
    if(!list) return;
    if(!keys.length){
      list.innerHTML = '<p class="nakr-cart-favorites__empty">Aucun favori pour le moment.</p>';
      return;
    }
    list.innerHTML = '';
    const entries = await Promise.all(keys.map(async key => {
      const parsed = parseKey(key);
      try {
        const product = await loadProduct(parsed.handle);
        return {key, parsed, product};
      } catch(e) { return null; }
    }));

    entries.forEach(entry => {
      if(!entry || !entry.product) return;
      const {key, parsed, product} = entry;
      const variant = variantFor(product, parsed.variantId);
      const image = (variant && variant.featured_image && (variant.featured_image.src || variant.featured_image)) || product.featured_image || (product.images && product.images[0]) || '';
      const price = variant ? variant.price : product.price;
      const variantTitle = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';
      const href = rootUrl.replace(/\/?$/, '/') + 'products/' + parsed.handle + (variant ? `?variant=${variant.id}` : '');
      const article = document.createElement('article');
      article.className = 'nakr-cart-favorite';
      article.innerHTML = `
        <a class="nakr-cart-favorite__image" href="${href}">${image ? `<img src="${image}" alt="${(product.title||'').replace(/"/g,'&quot;')}" loading="lazy">` : ''}</a>
        <div class="nakr-cart-favorite__copy">
          <a class="nakr-cart-favorite__title" href="${href}">${product.title || ''}</a>
          ${variantTitle ? `<p class="nakr-cart-favorite__variant">${variantTitle}</p>` : ''}
          <p class="nakr-cart-favorite__price">${money(price)}</p>
        </div>
        <button type="button" class="nakr-wishlist-heart nakr-cart-favorite__remove is-saved" data-nakr-wishlist-heart data-product-handle="${parsed.handle}"${variant ? ` data-variant-id="${variant.id}"` : ''} aria-label="Retirer des favoris" aria-pressed="true">${heartIcon()}</button>`;
      list.appendChild(article);
    });
  }

  let renderToken = 0;
  async function renderCartFavorites(){
    const containers = [...document.querySelectorAll('[data-nakr-cart-favorites]')];
    if(!containers.length) return;
    const keys = readWishlist();
    const token = ++renderToken;
    await Promise.all(containers.map(c => renderOneContainer(c, keys)));
    if(token !== renderToken) return;
    syncHearts();
  }

  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-nakr-wishlist-heart]');
    if(btn){
      e.preventDefault();
      e.stopPropagation();
      if(e.stopImmediatePropagation) e.stopImmediatePropagation();
      toggle(btn.dataset.productHandle, btn.dataset.variantId);
      return;
    }
    if(e.target.closest('[data-mattr-wishlist]')){
      setTimeout(() => { syncHearts(); renderCartFavorites(); }, 50);
    }
  }, true);

  function init(){
    injectHearts();
    renderCartFavorites();
    const observer = new MutationObserver(() => injectHearts());
    observer.observe(document.body, {childList:true, subtree:true});
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', () => { injectHearts(); renderCartFavorites(); });
  document.addEventListener('nakr:wishlist-changed', syncHearts);
})();
